import { useTween } from 'react-use';

import styles from './KnmEditBlockedNotification.module.scss';

const timeout = 5;
const INTERVAL = timeout * 60 * 1000;

interface IKnmEditBlockedNotificationProps {
  isPm?: boolean;
  names?: string[];
}

export const KnmEditBlockedNotification = ({ isPm, names }: IKnmEditBlockedNotificationProps) => {
  const time: number = useTween('linear', INTERVAL);
  const currentTime = (INTERVAL - time * INTERVAL) / 1000 / 60;
  const min = Math.floor(currentTime);
  const sec = Math.floor(60 * (currentTime < 1 ? currentTime : currentTime % min));

  return !names ? (
    <>{`В настоящий момент паспорт ${
      isPm ? 'ПМ' : 'КНМ'
    } редактируется другим пользователем. Возможность редактирования будет доступна через ${min}:${
      sec < 10 ? '0' : ''
    }${Number.isNaN(sec) ? 0 : sec}`}</>
  ) : (
    <ul className={styles.EditorList}>
      Cписок пользователей:
      {names.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};
